export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const ADD_RECOMMENDATION = 'ADD_RECOMMENDATION'
export const CANCEL_NEWRECOMMENDATION = 'CANCEL_NEWRECOMMENDATION'
export const SET_RECOMMENDATIONACTIVATION = 'SET_RECOMMENDATIONACTIVATION'



// WEBPACK FOOTER //
// ./src/store/modules/calibrate/types.js